import type { HomeCardsConfig } from '../../components/home-cards.tsx';

/** Cartões da Visão geral: FP&A (ADR 0097). */
export const FPA_CARDS: HomeCardsConfig = {
  queryKey: 'fpa',
  endpoint: '/fpa/home-cards',
  consultTo: '/fpa/pending',
  cards: [
    {
      id: 'review_blocks',
      section: 'pending',
      title: 'fpaCards.reviewBlocks.title',
      criterion: 'fpaCards.reviewBlocks.criterion',
      unit: 'fpaCards.reviewBlocks.unit',
      // A API manda a conferência da versão contada; sem versão aberta, a lista de versões.
      link: { to: '/fpa/planning' },
      attention: true,
    },
    {
      id: 'classification_exceptions',
      section: 'pending',
      title: 'fpaCards.classificationExceptions.title',
      criterion: 'fpaCards.classificationExceptions.criterion',
      unit: 'fpaCards.classificationExceptions.unit',
      link: { to: '/fpa/exceptions', search: { status: 'exception' } },
    },
    {
      id: 'classification_returned',
      section: 'pending',
      title: 'fpaCards.classificationReturned.title',
      criterion: 'fpaCards.classificationReturned.criterion',
      unit: 'fpaCards.classificationReturned.unit',
      link: { to: '/fpa/exceptions', search: { status: 'returned' } },
    },
    {
      id: 'actuals_review',
      section: 'pending',
      title: 'fpaCards.actualsReview.title',
      criterion: 'fpaCards.actualsReview.criterion',
      unit: 'fpaCards.actualsReview.unit',
      link: { to: '/fpa/actuals', search: { review: 'pending' } },
    },
    {
      id: 'unmapped_combinations',
      section: 'pending',
      title: 'fpaCards.unmappedCombinations.title',
      criterion: 'fpaCards.unmappedCombinations.criterion',
      unit: 'fpaCards.unmappedCombinations.unit',
      link: { to: '/fpa/actuals', search: { tab: 'mapping', mapping: 'unmapped' } },
    },
    {
      id: 'approval_blocked',
      section: 'pending',
      title: 'fpaCards.approvalBlocked.title',
      criterion: 'fpaCards.approvalBlocked.criterion',
      unit: 'fpaCards.approvalBlocked.unit',
      link: { to: '/fpa/planning', search: { approval: 'blocked' } },
      attention: true,
    },
  ],
};
